import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/CustomTable.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { getAgencies } from "views/Services/AgencyService.js";
import { Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

const useStylesPrincipal = makeStyles(stylePrincipal);

const useStyles = makeStyles(styles);

export default function AgenciesDashboard() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classesPrincipal = useStylesPrincipal();

  const [agencies, setAgencies] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const rowsForPage = 10;
  const tableRef = useRef();
  const classes = useStyles();

  const styleButton = {
    cursor: "pointer",
    padding: "0px !important",
  };

  useEffect(() => {
    if (localStorage.getItem("userType") !== "1") {
      window.location.href = "/admin/home";
    }
  }, []);

  useEffect(() => {
    fetchAgencies(currentOffset);
  }, [dispatch]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      handleChangePage(0);
      goToFirstPage();
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [search]);

  const fetchAgencies = async (offset) => {
    setLoading(true);
    const data = {
      start: offset,
      length: 50,
      search: {
        value: search,
        regex: false,
      },
    };
    const result = await dispatch(getAgencies(data));
    setAgencies(result.payload.data || []);
    setTotalRows(result.payload.data.length || 0);
    setCurrentOffset(offset);
    setLoading(false);
  };

  const handleChangePage = (currentPage) => {
    if ((currentPage * rowsForPage) % 50 === 0) {
      fetchAgencies(currentPage * rowsForPage);
    }
  };

  const goToFirstPage = () => {
    if (tableRef.current && tableRef.current.resetPage) {
      tableRef.current.resetPage(0);
    }
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    if (name === "search") {
      setSearch(value);
    }
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12}>
              <Card>
                <CardHeader>
                  <div
                    className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                  >
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={9}>
                        Agencies
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={3}
                        style={{ marginTop: "15px" }}
                      >
                        <Button
                          variant="green"
                          onClick={() => {
                            window.location.href = "/admin/agency";
                          }}
                          style={{ float: "right" }}
                        >
                          Add New Agency
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </div>
                  <GridContainer>
                    <GridItem xs={12} style={{ marginTop: "15px" }}>
                      <GridContainer>
                        <GridItem xs={0} sm={0} md={9}></GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Search"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              name: "search",
                              id: "search",
                              value: search,
                              onChange: handleFormChange,
                            }}
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <div className="content">
                  <div className="table-responsive">
                    <Table
                      ref={tableRef}
                      tableHead={[
                        "Producer Code",
                        "Agency Name",
                        "Address",
                        "City",
                        "State",
                        "Phone",
                        "Status",
                        "Action",
                      ]}
                      tableData={agencies.map((agency) => [
                        agency.producer_code,
                        agency.agency_name,
                        agency.address,
                        agency.city,
                        agency.state,
                        agency.phone,
                        agency.is_active === "1" ? "Enable" : "Disable",
                        <GridItem
                          onClick={() => {
                            window.location.href = `/admin/agency/${agency.id}`;
                          }}
                          md={2}
                          style={styleButton}
                        >
                          <Tooltip title="Edit Agency" placement="top" arrow>
                            <EditIcon
                              style={{ color: "#13816F" }}
                              fontSize="small"
                            ></EditIcon>
                          </Tooltip>
                        </GridItem>,
                      ])}
                      rowsPerPage={rowsForPage}
                      totalRows={totalRows}
                      changePage={handleChangePage}
                      loading={loading}
                    />
                  </div>
                </div>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
